import * as React from 'react';

import { ProcessSection, IProcessAccordionItem, IProcessStep } from 'shared/components/ProcessSection';
import { useAccordion, useTabs } from 'shared/hooks';

import icon01 from 'shared/components/ProcessSection/assets/icon_01.svg';
import icon02 from 'shared/components/ProcessSection/assets/icon_02.svg';
import icon03 from 'shared/components/ProcessSection/assets/icon_03.svg';
import accordionSale1 from 'shared/components/ProcessSection/assets/accordion-sale-1.png';
import accordionSale2 from 'shared/components/ProcessSection/assets/accordion-sale-2.png';
import accordionSale3 from 'shared/components/ProcessSection/assets/accordion-sale-3.png';
import accordionSale4 from 'shared/components/ProcessSection/assets/accordion-sale-4.png';
import accordionSale5 from 'shared/components/ProcessSection/assets/accordion-sale-5.png';
import accordionBuy1 from 'shared/components/ProcessSection/assets/accordion-buy-1.png';
import accordionBuy2 from 'shared/components/ProcessSection/assets/accordion-buy-2.png';
import accordionBuy3 from 'shared/components/ProcessSection/assets/accordion-buy-3.png';

const SALE_ITEMS: IProcessAccordionItem[] = [
  {
    title: 'Подготовит объект',
    text: 'Поможет определить рыночную цену и подскажет, что можно улучшить, чтобы квартира выглядела привлекательнее и продалась быстрее',
    image: accordionSale1,
  },
  {
    title: 'Подключит рекламу',
    text: 'Разместит объявление на ключевых площадках и настроит максимальное продвижение на Циане, чтобы ваш объект выделялся среди остальных и его увидело больше реальных покупателей',
    image: accordionSale2,
  },
  {
    title: 'Заберет на себя всю рутину',
    text: 'Будет отвечать на звонки и сообщения, организовывать и проводить показы, напоминать о договорённостях и держать весь процесс под контролем',
    image: accordionSale3,
  },
  {
    title: 'Поможет удержать цену',
    text: 'Займётся переговорами с покупателями: не допустит необоснованного торга и поможет сохранить цену',
    image: accordionSale4,
  },
  {
    title: 'Оформит сделку',
    text: 'Проверит документы, подготовит договор и сопроводит вас на сделке до передачи денег и ключей',
    image: accordionSale5,
  },
];

const BUY_ITEMS: IProcessAccordionItem[] = [
  {
    title: 'Проведёт переговоры',
    text: 'Будет торговаться за выгодные условия и цену, защитит ваши интересы',
    image: accordionBuy1,
  },
  {
    title: 'Проверка',
    text: 'Проанализирует историю квартиры и собственников, проверит, есть ли обременения и другие риски, до подписания документов',
    image: accordionBuy2,
  },
  {
    title: 'Сэкономит ваши нервы и деньги',
    text: 'Вместо вас займётся сложными вопросами, чтобы избежать ошибок и не потерять деньги',
    image: accordionBuy3,
  },
];

const STEPS: IProcessStep[] = [
  {
    icon: icon01,
    title: 'Узнаем детали',
    content: <>Менеджер Циана свяжется с&nbsp;вами, чтобы&nbsp;уточнить детали и&nbsp;подтвердить заявку</>,
  },
  {
    icon: icon02,
    title: 'Подберём профи',
    content: <>Назначим агента с учётом ваших пожеланий, включая локацию, пол, желаемые сроки сделки</>,
    note: 'Если не сработаетесь — подберём другого',
  },
  {
    icon: icon03,
    title: 'Риелтор начнёт работу',
    content: null,
    isFull: true,
  },
];

export const ProcessSectionContainer: React.FC = () => {
  const { setActiveTab, isActive: isTabActive } = useTabs<'sale' | 'buy'>('sale');
  const saleAccordion = useAccordion(0);
  const buyAccordion = useAccordion(0);

  return (
    <ProcessSection
      steps={STEPS}
      saleItems={SALE_ITEMS}
      buyItems={BUY_ITEMS}
      isTabActive={isTabActive}
      onTabChange={setActiveTab}
      saleIsOpen={saleAccordion.isOpen}
      onSaleToggle={saleAccordion.toggle}
      buyIsOpen={buyAccordion.isOpen}
      onBuyToggle={buyAccordion.toggle}
    />
  );
};
